var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 299,
    viewBox: "0 0 321 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M305.275 284.668C246.03 360.086 123.674 362.834 31.9844 290.807C-59.7051 218.779 -86.0067 99.2515 -26.7619 23.834C32.4829 -51.5835 57.3189 69.8099 149.008 141.837C240.698 213.865 364.52 209.251 305.275 284.668Z",
    fill: "#873FE2",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse21);
export default __webpack_public_path__ + "static/media/Ellipse 21.52af45cffacf2039b4ae66fe8dea8942.svg";
export { ForwardRef as ReactComponent };